<template>
  <div class="video-section section-content"
       data-aos="fade"
       data-aos-duration="2000">
    <div class="video-container">
      <div class="video-container__placeholder"
           v-if="!playingVideo">
        <img src="../../assets/bg-poly.png" class="hero-shape" alt="shape"/>
        <div class="video-container__placeholder__overlay">
          <video class="video-container__placeholder__overlay__vid" preload="auto" autoplay="true" loop="loop" muted="muted" volume="0">
            <source :src="`${baseUrl}gradient-vid.mp4`" type="video/mp4">
          </video>
          <div class="video-container__placeholder__overlay__text">
            <img src="../../assets/together-we-go-far.png" alt="Together We Go Far" class="home-hero-text">
            <a href="https://vimeo.com/523953003" ref="playButton" class="video-container__placeholder__overlay__text__play">
              <div class="video-container__placeholder__overlay__text__play__button">
                <FontAwesomeIcon icon="play" />
              </div>
              <p class="video-container__placeholder__overlay__text__play__text">
                Watch the Video
              </p>
            </a>
          </div>
          <div class="video-container__placeholder__overlay__ill">
            <img src="../../assets/purple-hair-doc-female.png" class="doc-1" alt="Doctor">
            <img src="../../assets/purple-hair-doc.png" class="doc-2" alt="Doctor">
            <img src="../../assets/blue-hair-doc-female.png" class="doc-3" alt="Doctor">
            <img src="../../assets/blue-hair-doc.png" class="doc-4" alt="Doctor">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HomeHeroVideo',
  components: { },
  data: function () {
    return {
      playingVideo: false,
      baseUrl: process.env.BASE_URL
    };
  },
  mounted () {
    $(this.$refs.playButton).magnificPopup({
      type: 'iframe',
      fixedContentPos: false
    });
    $(window).scroll(function () {
      var scrollPos = $(window).scrollTop();
      if ($(window).width() > 640) {
        $('.doc-1').css({
          transform: 'translateY(-' + scrollPos / 8 + 'px)'
        });
        $('.doc-2').css({
          transform: 'translateY(-' + scrollPos / 15 + 'px)'
        });
        $('.doc-3').css({
          transform: 'translateY(-' + scrollPos / 4 + 'px)'
        });
        $('.doc-4').css({
          transform: 'translateY(-' + scrollPos / 20 + 'px)'
        });
      }
    });
    $(window).resize(function () {
      if ($(window).width() < 1024) {
        $('.doc-1').css({
          transform: 'translateY(0)'
        });
        $('.doc-2').css({
          transform: 'translateY(0)'
        });
        $('.doc-3').css({
          transform: 'translateY(0)'
        });
        $('.doc-4').css({
          transform: 'translateY(0)'
        });
      }
    });
  },
  methods: {
    playVideo: function () {
      this.playingVideo = true;
      this.$refs.player.play();
      /* eslint-disable */
      $(".vimeo-player iframe").css("max-height", "80vh");
      $(".board-chair *[data-aos]").addClass("aos-animate");
      /* eslint-enable */
    },
    onPause: function () {
      this.playingVideo = false;
      /* eslint-disable */
      $(".board-chair *[data-aos]").removeClass("aos-animate");
      /* eslint-enable */
    }
  }
};
</script>
